import * as localStorageKeys from 'constants/localStorageKeys'

export default {
    isOpen: false,
    userId: localStorage.getItem(localStorageKeys.USER_ID) || '',
    session: JSON.parse(localStorage.getItem(localStorageKeys.SESSION)) || {
        timeStamp: 0,
        id: ''
    },
    startTimeStamp: Date.now(),
    clientIp: '',
    countryCode: '',
    language: 'en'
}
